import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef for the processed flag. Set it synchronously at the start
    // This prevents race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (sessionIdMatch && sessionIdMatch[1]) {
          const sessionId = sessionIdMatch[1];
          const user = await handleGoogleCallback(sessionId);
          
          toast.success('Login successful!');
          
          // Clear the hash
          window.history.replaceState(null, '', window.location.pathname);
          
          // Redirect based on role
          if (user.role === 'admin') {
            navigate('/admin', { replace: true });
          } else if (user.role === 'shop_owner') {
            navigate('/owner', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        } else {
          throw new Error('No session ID found');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-zinc-900 mx-auto mb-4"></div>
        <p className="text-zinc-600">Completing authentication...</p>
      </div>
    </div>
  );
}
